import type { EventOccurrenceViewModel, FunctionViewModel } from '@trinnvis/dabih-api-client';
import type { OrganizationState } from '../../types';
import type { NameEntry } from '../employees/name-entry';
import type { LocalDate } from '../../../utilities/local-date';
import type { EventInstance } from './event-instance';
import { taskEventTodoItemsFunction } from './task-event-todo-items-function';
import { taskEventInstancesFunction } from './task-event-instances-function';
import type { ContactsAsUsers } from '../partners/contacts-as-users';
import type { SelectDropdownOption } from '../../../library/editors/elements/select-dropdown-option';

export function taskEventsInstances(
  events: EventOccurrenceViewModel[],
  organization: OrganizationState | undefined,
  employeeNamesI: NameEntry[],
  functions: FunctionViewModel[],
  contacts: ContactsAsUsers[],
  organizationid: number,
  currentUserUuid: string | undefined,
  singleUserVersion: boolean,
  today: LocalDate,
  employeesAndContacts: SelectDropdownOption[],
): EventInstance[] {
  if (organization === undefined) {
    return [];
  }
  const todoItems = taskEventTodoItemsFunction(
    events,
    organization,
    employeesAndContacts,
    employeeNamesI,
    functions,
    contacts,
    organizationid,
    currentUserUuid ? currentUserUuid : '',
    singleUserVersion,
  );
  const datedItems = taskEventInstancesFunction(
    events,
    organization,
    employeesAndContacts,
    employeeNamesI,
    contacts,
    functions,
    organizationid,
    currentUserUuid ? currentUserUuid : '',
    today,
    singleUserVersion,
    '318434',
  );
  return todoItems.concat(datedItems);
}
